import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-4" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Заказ (ID): " + _toDisplayString(_ctx.item.id), 1)
    ]),
    _createElementVNode("p", _hoisted_4, "Дата создания: " + _toDisplayString(_ctx.item.createdAt), 1),
    _createElementVNode("p", null, "Компания: " + _toDisplayString(_ctx.item.company ? _ctx.item.company.shortName : '-'), 1),
    _createElementVNode("p", null, "Логист: " + _toDisplayString(_ctx.item.logistName), 1),
    _createElementVNode("p", null, " Направление: " + _toDisplayString(_ctx.item.fromCity ? _ctx.item.fromCity.name : '-') + " - " + _toDisplayString(_ctx.item.toCity ? _ctx.item.toCity.name : '-'), 1)
  ]))
}